import { useContactsGroupsQuery } from '@dashboard/generated/wp/platform';
import { useCurrentPage } from '@dashboard/hooks/route/useCurrentPage';

export default function useCurrentGroups() {
  const page = useCurrentPage();
  return useContactsGroupsQuery({ fetchPolicy: 'network-only', variables: { page } });
}
